import { AuthCardAppleButtonBase } from "@/components/auth/apple/auth-card-apple-button-base";
import { observer } from "mobx-react-lite";
import { FC } from "react";

export interface AuthCardLogInWithAppleButtonProps {
  onClick: () => void;
}

export const AuthCardLogInWithAppleButton: FC<AuthCardLogInWithAppleButtonProps> = observer(
  ({ onClick }) => {
    return <AuthCardAppleButtonBase label="Sign in with Apple" onClick={onClick} />;
  }
);
